import usePageTitle from '@/hooks/use-page-title';
import { Link, Route, Routes } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import FormulaireResil from "@/pages/resiliation/formulaire-resil";
import { useContractsData } from '@/hooks/api/use-contracts';
import { hasContractVAEUnder14Days } from '@/lib/contracts';

const Resilier = () => {
    const canRenounce = hasContractVAEUnder14Days(useContractsData());
    usePageTitle(canRenounce ? 'Renoncer' : 'Résilier');
    return (
        <div className={'w-full'}>
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3.5 h-3.5" />
                <span className="text-foreground font-medium">{canRenounce ? 'Renoncer à mon contrat' : 'Résilier'}</span>
            </nav>
            <h1 className="text-xl sm:text-2xl font-bold mt-4">{canRenounce ? 'Renoncer à mon contrat' : 'Résilier mon contrat'}</h1>
            <div className="mt-4">
            <Routes>
                <Route index element={<FormulaireResil />} />
            </Routes>
            </div>
        </div>
    );
};

export default Resilier;
